import React, { useState } from "react";
import { CollapseArrow } from "~/assets/svg/InterfaceIcon";
import bgImg from "~/assets/img/bg-evaluate-history.png";
import moment from "moment";
import { useTranslation } from "react-i18next";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useGlobalStore } from "~/store";

const RequestClosed = ({ setEvaluateCategoryModal, setCurrentStep, detailData, company }) => {
	const { t } = useTranslation();
	const [makeVisible, setMakeVisible] = useState(false);
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	return (
		<section className="c__card evaluate-card request-card">
			<div className="top">
				<div>
					<h5 className="waiting-text pre">
						{t("pages.investment.InvestEvalPage.detail.components.waitingText")}
					</h5>
					<p>
						{t("pages.investment.InvestEvalPage.detail.components.date")}{" "}
						{moment(detailData.regDate).format("YYYY-MM-DD HH:mm:ss")}
					</p>
					<button
						type="button"
						className="btn-item"
						onClick={() => setEvaluateCategoryModal(true)}
					>
						{t("pages.investment.InvestEvalPage.detail.components.button")}
					</button>
				</div>
				<div className="img-wrap">
					<div>
						<img
							src={bgImg}
							alt={t("pages.investment.InvestEvalPage.detail.components.imageAlt1")}
						/>
					</div>
				</div>
			</div>
			<div className="content ">
				<div className="top">
					<h3 className="title">{detailData.title}</h3>
					<div className="c__dropdown-wrap">
						<button
							className="btn-dropdown visible"
							onClick={() => setMakeVisible((state) => !state)}
						>
							<ul className="logo-group">
								{detailData.Judge?.map((d) => (
									<li className="img-wrap" key={d.idx}>
										<img
											src={
												d.VcUser.img ||
												(theme === "dark"
													? DarkDefaultProfileImg
													: LightDefaultProfileImg)
											}
											alt={t(
												"pages.investment.InvestEvalPage.detail.components.imageAlt2"
											)}
										/>
										{/*<img src={d.VcUser.img || lightProfileImg} alt="심사역" />*/}
									</li>
								))}
							</ul>
						</button>
						<div className={`c__dropdown ${makeVisible ? "visible" : ""}`}>
							<p className="dropdown-title">
								{t("pages.investment.InvestEvalPage.detail.components.judge")}
								<span className="num">{detailData.Judge?.length}</span>
							</p>
							<ul className="detail-list">
								{detailData?.Judge?.map((d) => (
									<li className="c__dropdownItem" key={d.idx}>
										<div className="img-wrap">
											<img
												src={
													d.VcUser.img ||
													(theme === "dark"
														? DarkDefaultProfileImg
														: LightDefaultProfileImg)
												}
												alt={t(
													"pages.investment.InvestEvalPage.detail.components.imageAlt3"
												)}
											/>
											{/*<img src={d.VcUser.img || lightProfileImg} alt="기업로고" />*/}
										</div>
										<dl>
											<dt>{company?.name}</dt>
											<dd>{d.VcUser.UserProfile.name}</dd>
										</dl>
									</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</div>
			<button type="button" onClick={() => setCurrentStep("opened")} className="btn-collapse">
				{t("pages.investment.InvestEvalPage.detail.components.collapse")}
				<CollapseArrow />
			</button>
		</section>
	);
};

export default RequestClosed;
